<template>
  <base-dialog show-close :visible.sync="visible" class="delete-department-dialog" width="340px">
    <template v-slot:header>删除</template>
    操作删除后,该部门员工将移入公司,是否删除?
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import { deleteDepartment } from "@/api/department"

export default {
  name: "delete-department-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    return {
      visible: false,
      departmentId: ""
    }
  },
  methods: {
    open(departmentId) {
      this.departmentId = departmentId
      this.visible = true
    },
    submit() {
      deleteDepartment(this.departmentId).then(() => {
        this.$message.success("删除成功")
        this.$emit("change")
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-department-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 18px 60px 8px 24px;
      color: unset;
    }
  }
}
</style>
